import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=a35e4106&scoped=true&"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts&"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=a35e4106&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35e4106",
  null
  
)

export default component.exports